import { useLocation } from 'react-router-dom';
import { useEffect } from 'react';
import { getRouteSEO, getSiteOrigin, SITE_NAME, SITE_DEFAULT_LOCALE } from './config';
import { applyHead } from './head';
import {
  clearSchemas,
  applySchemas,
  buildOrganizationSchema,
  buildWebSiteSchema,
  buildWebPageSchema,
  buildArticleSchema,
  buildBreadcrumbList,
} from './schema';
import { articles } from '@/mocks/articles';

export default function SeoManager() {
  const { pathname } = useLocation();

  useEffect(() => {
    const seo = getRouteSEO(pathname);
    if (!seo) {
      // No SEO data for this route (e.g. catch-all / not-found).
      return;
    }

    const origin = getSiteOrigin();
    const canonicalUrl = `${origin}${seo.path === '/' ? '/' : seo.path}`;

    applyHead({
      title: seo.title,
      description: seo.description,
      keywords: seo.keywords,
      canonicalUrl,
      ogUrl: canonicalUrl,
      type: seo.type,
      locale: SITE_DEFAULT_LOCALE,
    });

    // Build and inject Schema.org JSON-LD separately from head metadata.
    clearSchemas();
    const schemas: object[] = [];

    if (seo.path === '/') {
      schemas.push(buildOrganizationSchema(origin));
      schemas.push(buildWebSiteSchema(origin));
    } else if (pathname.startsWith('/article/')) {
      const slug = pathname.replace('/article/', '').replace(/\/+$/, '');
      const article = articles.find((a) => a.slug === slug);
      if (article) {
        schemas.push(buildArticleSchema(article, origin));
        schemas.push(
          buildBreadcrumbList([
            { name: SITE_NAME, url: `${origin}/` },
            { name: article.title, url: canonicalUrl },
          ]),
        );
      }
    } else {
      schemas.push(buildWebPageSchema(seo.title, canonicalUrl, seo.description));
    }

    applySchemas(schemas);
  }, [pathname]);

  return null;
}